import { createElement, useState } from 'react';
import { Image } from '@alilc/lowcode-materials';
import './index.scss';
const Navigation = function BottomNavigation({ itemArray, selectedColor, onClick, __designMode, ...otherProps }) {
    const [activeNum, setActiveNum] = useState(0);
    const clickHandle = (index, pageId) => {
        setActiveNum(index);
        if (__designMode == 'design') {
            return;
        }
        console.log('clickHandle', pageId);
        onClick(pageId);
    };
    return (createElement("div", { className: "bottom-navigation", ...otherProps },
        createElement("div", { className: "navigation-panel" }, itemArray.map((item, index) => {
            return createElement("div", { className: "navigation-panel-item", onClick: () => clickHandle(index, item.pageId), style: {
                    color: activeNum === index ? selectedColor ?? '#4598FF' : '',
                    fontWeight: activeNum === index ? "bold" : "500"
                } },
                createElement(Image, { className: "navigation-item-image", src: activeNum === index ? item.selectedIcon ?? item.icon : item.icon, style: { width: '24.5px', height: '24.5px' } }),
                createElement("span", { style: { fontSize: "12px" } }, item.text));
        }))));
};
export default Navigation;
